module.exports = __webpack_public_path__ + "static/media/AdobeStock_198887954.32190bc1.jpeg";